import { useTranslation } from "react-i18next";
import { Card, Flex, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

import GlobeIcon from "@/assets/icons/globe.svg?react";
import CommunityIcon from "@/assets/icons/community.svg?react";
import BaseButton from "@/components_v2/Button/BaseButton.js";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer.js";
import {
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

import "./styles.css";

const { Text } = Typography;

const SubmissionSuccess = () => {
  const { t } = useTranslation();

  return (
    <div className="submission-success-container">
      <Card className="submission-success-card">
        <Flex vertical align="center" gap="large">
          <CheckCircleOutlined className="success-icon" />
          <h1 className="header-l-medium">
            {t("survey.labels.reportSubmittedSuccessfully")}
          </h1>
          <Text>{t("survey.labels.reportSubmittedDescription")}</Text>

          <Flex
            className="report-versions-container"
            justify="center"
            gap="large"
          >
            <Card className="report-version-card-public">
              <Flex vertical align="center" gap="small">
                <BaseSvgRenderer component={GlobeIcon} width="40" height="40" />
                <h2 className="header-m-medium">
                  {t("survey.labels.publicWebsiteVersion")}
                </h2>
                <Text>
                  {t("survey.labels.publicWebsiteVersionDescription")}
                </Text>
              </Flex>
            </Card>
            <Card className="report-version-card-community">
              <Flex vertical align="center" gap="small">
                <BaseSvgRenderer
                  component={CommunityIcon}
                  width="40"
                  height="40"
                />
                <h2 className="header-m-medium">
                  {t("survey.labels.communityVersion")}
                </h2>
                <Text>{t("survey.labels.communityVersionDescription")}</Text>
              </Flex>
            </Card>
          </Flex>

          <Text>{t("survey.labels.manageReportsHint")}</Text>

          <Flex gap="small">
            <BaseButton
              variant={BUTTON_VARIANTS.TERTIARY}
              to={"/"}
              type={BUTTON_TYPES.LINK}
            >
              {t("survey.labels.returnToDashboard")}
            </BaseButton>
            <BaseButton
              variant={BUTTON_VARIANTS.PRIMARY}
              to={"/reports/views"}
              type={BUTTON_TYPES.LINK}
            >
              {t("survey.labels.goToPublishAndShare")}
            </BaseButton>
          </Flex>
        </Flex>
      </Card>
    </div>
  );
};

export default SubmissionSuccess;
